export default {
  DELIVERED: 'D',
  EX_FARM: 'C'
}
